import React from 'react';
import { PhoneCountryCodeType } from '@bus/models';
import { PhoneNumberFormField } from '../../../../components/Fieldset/PhoneNumberFormField';
import { SelectFormField } from '../../../../components/Fieldset/SelectFormField';
import { TextInputFormField } from '../../../../components/Fieldset/TextInputFormField';
import { createOptionsList } from '../../../../services/common/miscUtils';
import { BusinessCustomerTypesEnum } from '../../CustomerDataPage/customerDataPage.model';
import { BusinessProspectFormModel } from './formModel';
import { SearchableTextInputFormField } from '../../../../components/Fieldset/SearchableTextInputFormField';

const typeSafeFormFieldName = (formFieldName: keyof BusinessProspectFormModel) => formFieldName;

export const createFormInputs = (isDisabled: boolean) => {
  return {
    businessCustomerType: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('businessCustomerType')}
        labelTranslationKey="prospectPage:business:fields:entityFormProspectPage:label"
        optionList={createOptionsList(BusinessCustomerTypesEnum, 'prospectPage:business', 'entityFormProspectPage')}
      />
    ),
    legalName: (handleShowingCustomerSearchModal: () => void) => (
      <SearchableTextInputFormField
        fieldName={typeSafeFormFieldName('legalName')}
        labelTranslationKey="prospectPage:business:fields:legalName:label"
        placeholderTranslationKey="prospectPage:business:fields:legalName:placeholder"
        handleSearch={handleShowingCustomerSearchModal}
        isDisabled={isDisabled}
      />
    ),
    countryCode: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('countryCode')}
        labelTranslationKey="prospectPage:business:fields:countryCode:label"
        optionList={createOptionsList(PhoneCountryCodeType, 'prospectPage:business', 'countryCode')}
        isDisabled={isDisabled}
      />
    ),
    email: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('email')}
        labelTranslationKey="prospectPage:business:fields:email:label"
        placeholderTranslationKey="prospectPage:business:fields:email:placeholder"
        isDisabled={isDisabled}
        validateOnChange
      />
    ),
    mobileNumber: () => (
      <PhoneNumberFormField
        fieldName={typeSafeFormFieldName('mobileNumber')}
        labelTranslationKey="prospectPage:business:fields:mobileNumber:label"
        placeholderTranslationKey="prospectPage:business:fields:mobileNumber:placeholder"
        type="mobile"
        isDisabled={isDisabled}
      />
    ),
  };
};
